import React, {useEffect, useState } from "react";
import { getAllAdmins, attendanceAnalytics } from "../../utils/helper";
import moment from "moment";
import { alertError } from "../../utils/alerts";


const INIT_STATE = {
    employee : "All",
    year:"",
    week:"",
    cycle:"",
    month:"",
};

export default function AttendanceReport() {
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState(INIT_STATE);
    const [reports, setData] = useState([]);
    const [counts, setCounts] = useState([]);
    const [employees, setEmployees] = useState("");

    const [date] = useState(new Date());
    // const [query, setQuery] = useState(null);

    useEffect(() => {
        getAllAdmins()
            .then((res) => {
                setEmployees(res.data.data);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        setState((prev) => ({
            ...prev,
            day: (moment(date).format("dddd")) || "",
            date: (date && moment(date).format("MMMM Do YYYY")) || "",
            year: (date && moment(date).format("YYYY")) || "",
            month: (date && moment(date).format("MMMM")) || "",
            lastmonth : (date && moment(date).subtract(1,'months').format("MMMM")) || "",
            week: (moment(date).format("WW")) || "",
            lastweek: (moment(date).subtract(7,'days').format("WW")) || "",
        }));
    }, [date]); 

    useEffect(() => {
        if(state.cycle !== "" && state.employee !== ""){
            let data;
            if(state.cycle === "thisweek"){
                data = {
                    employee: state.employee,
                    year: state.year,
                    cycle: state.cycle,
                    week: state.week,
                }
            }else if(state.cycle === "lastweek"){
                data = {
                    employee: state.employee,
                    year: state.year,
                    cycle: state.cycle,
                    week: state.lastweek,
                }
            }else if(state.cycle === "thismonth"){
                data = {
                    employee: state.employee,
                    year: state.year,
                    cycle: state.cycle,
                    month: state.month,
                }
            }else if(state.cycle === "lastmonth"){
                data = {
                    employee: state.employee,
                    year: state.year,
                    cycle: state.cycle,
                    month: state.lastmonth,
                }
            }
            // setQuery(data);
                        
            setLoading(true);
            attendanceAnalytics(data)
                .then((res) => {
                    if(res.data.success){
                        setCounts(res.data.sums);
                        setData(res.data.data);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    alertError(err?.response?.data?.error);
                }); 

                
        }
    }, [state]);


    const handleChange = (e) => {
        e.persist();
        setState((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }


    return (
        <>            
            <h1 className="dash-title">Attendance Report</h1>

            <div className="row dash-row">
                
                <div className="col-md-12 col-sm-12 col-12">

                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Attendance Report</div>
                        </div>
                        <div className="card-body">
                            <form method="post" encType="multipart/form-data">
                                <div className="row">
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Select Employee: <span>*</span></label>
                                        <select className="form-control form-select" name="employee" id="employee" required  
                                        onChange={handleChange} >
                                            <option value="All">All Employees</option>
                                            {employees && employees.map((user, i) => (
                                            <option value={user._id} key={i}>
                                                {user.first_name} {" "} {user.last_name}
                                            </option>
                                        ))}
                                        </select>
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Select Year: <span>*</span></label>
                                        <select className="form-control form-select" name="year" id="year" required  
                                        onChange={handleChange} >
                                            <option value="">Select...</option>
                                            <option value="2023">2023</option>
                                            <option value="2024">2024</option>
                                        </select>
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Select Cycle: <span>*</span></label>
                                        <select className="form-control form-select" name="cycle" id="cycle" required  
                                        onChange={handleChange} >
                                            <option value="">Select...</option>
                                            <option value="thisweek">This Week ({"Week "} {state.week})</option>
                                            <option value="lastweek">Last Week ({"Week "} {state.lastweek})</option>
                                            <option value="thismonth">This Month ({state.month} {state.year})</option>
                                            <option value="lastmonth">Last Month  ({state.lastmonth} {state.year})</option>
                                        </select>
                                    </div>
                                    {/* <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <button 
                                            type="submit" 
                                            disabled={loading} 
                                            className="btn btn-primary" 
                                        >
                                            EXPORT REPORT
                                        </button>
                                    </div> */}
                                </div>
                            </form>
                        </div>
                    </div>
                    
                    {(!loading && reports && counts) ?  <>
                    <div className="card spur-card">
                        <div className="card-header">
                            <div className="spur-card-title">Attendance Report</div>
                        </div>
                        <div className="card-body">
                            <div className="statistics mb-4">
                                {counts && counts.length > 0 ? 
                                <div className="row">
                                    {counts && counts.map((item, i) => (
                                        <div className="col-md-4 col-4 text-center" key={i}>
                                            <div className="stats-box">
                                                <p>{item.name && item.name}</p>
                                                <h3 className="text-info">
                                                    {item.count && item.count}
                                                </h3>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                : null }
                            </div>



                            <div className="my_profile">
                                <div className="table-responsive">
                                    {(reports && reports.length > 0) ? 
                                    <table className="table text-left text-caps table-bordered" id="myTable">
                                        <thead><tr>
                                            <th>SN</th>
                                            <th>Staff</th>
                                            <th>Date</th>
                                            <th>ClockIn Location</th>
                                            <th>Week</th>
                                            <th>TimeIn</th>
                                            <th align="center">TimeOut</th>
                                        </tr></thead>
                                        <tbody>
                                            {reports && reports.map((row, index) => 
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>
                                                        {row.employee && row.employee?.first_name} {row.employee && row.employee?.last_name}
                                                    </td>
                                                    <td>{row?.date && row?.date}</td>
                                                        <td>
                                                            {row.location && row.location}
                                                        </td>
                                                        <td>
                                                            {row.week}
                                                        </td>
                                                        <td><span className={row.timeIn >= "8:30:00 AM" ? `badge badge-danger` : `badge badge-success`}>
                                                            {row.timeIn} </span>
                                                        </td>
                                                        <td>{row.timeOut ? row.timeOut : "-- • --"}
                                                        </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table> : 
                                    <div className="alert alert-danger myerror d-block">No Attendance record was found for your selected query.</div> }
                                </div>
                            </div>
                        </div>
                    </div>
                    </> : null }

                </div>
            </div>
        </>
    );
}
